import { Module, Mutation, VuexModule, Action } from 'vuex-module-decorators';

import container from '@/container';
import { FetchServiceContract, CONTRACTS } from '@/core/contracts';
import { Permission, Role } from '@/dto';

interface RoleState {
    currentRole?: Role;
    permissions?: { [id: number]: Permission };
}

@Module({ name: 'role', namespaced: true })
export default class RoleModule extends VuexModule implements RoleState {
    public _currentRole?: Role = undefined;
    public _permissions?: { [id: number]: Permission } = undefined;

    get currentRole() {
        return this._currentRole;
    }

    get permissions() {
        return this._permissions;
    }

    @Action
    public async fetchRole(args: { contextId: string }): Promise<any> {
        const { contextId } = args;
        const fetchService = container.get<FetchServiceContract>(
            CONTRACTS.FetchService
        );

        const payload = await fetchService.get<Role>(
            `/contexts/${contextId}/users/current/role`
        );
        this.setRole(payload);
        this.setPermissions(payload.permissions);
    }

    @Mutation
    private setRole(currentRole: Role) {
        this._currentRole = currentRole;
    }

    @Mutation
    private setPermissions(permissions?: Permission[]) {
        const dict: { [id: number]: Permission } = {};

        if (permissions) {
            for (const permission of permissions) {
                dict[permission.code] = permission;
            }
        }

        this._permissions = dict;
    }
}
